import { Grid2, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../../../theme";

interface DaysPerWeekInputProps {
	readonly value: number | null;
	readonly onChange: (value: number) => void;
	readonly touched: boolean;
	readonly error: string | undefined;
	readonly inline?: boolean;
	readonly visible?: boolean;
}

export default function DaysPerWeekInput({
	value,
	onChange,
	touched,
	error,
	inline = false,
	visible = true
}: DaysPerWeekInputProps) {
	const { t } = useTranslation();

	if (!visible) {
		return null;
	}

	if (inline) {
		return (
			<Grid2
				size={{ xs: 12 }}
				mt={3}
				sx={{
					visibility: visible ? "visible" : "collapse"
				}}
			>
				<Typography
					variant="body1"
					component={"span"}
					sx={{ mb: 1, color: zoullooColors.grey[700] }}
				>
					{t("freelancerOnboardingMyAvailability.missionTimeCommitment")}
					&nbsp; &nbsp;
					<TextField
						type="number"
						value={value}
						onChange={e => {
							const newValue = Math.max(
								1,
								Math.min(5, Number.parseInt(e.target.value) || 1)
							);
							onChange(newValue);
						}}
						size="small"
						slotProps={{
							input: {
								inputProps: {
									min: 1,
									max: 5,
									style: {
										textAlign: "center",
										width: "60px"
									}
								}
							},
							htmlInput: {
								style: {
									MozAppearance: "textfield"
								}
							}
						}}
						sx={{
							top: "-9px",
							width: "80px",
							"& .MuiOutlinedInput-root": {
								height: "40px",
								"& fieldset": {
									borderColor: zoullooColors.grey[400]
								},
								"&:hover fieldset": {
									borderColor: zoullooColors.grey[700]
								},
								"&.Mui-focused fieldset": {
									borderColor: zoullooColors.secondary?.main || "#6366f1"
								}
							},
							"& input[type=number]": {
								WebkitAppearance: "auto",
								MozAppearance: "textfield"
							},
							"& input[type=number]::-webkit-outer-spin-button": {
								WebkitAppearance: "auto",
								opacity: 1
							},
							"& input[type=number]::-webkit-inner-spin-button": {
								WebkitAppearance: "auto",
								opacity: 1
							}
						}}
					/>
					&nbsp; &nbsp;
					{t("freelancerOnboardingMyAvailability.daysPerWeek")}
				</Typography>
				{touched && error && (
					<Grid2 size={{ xs: 12 }}>
						<Typography color="error" variant="body1">
							{error}
						</Typography>
					</Grid2>
				)}
			</Grid2>
		);
	}

	return null;
}
